import React, { useState, useEffect, useRef } from 'react'
import {
  ButtonToolbar,
  Tooltip,
  Whisper,
  Popover,
  Icon,
  Dropdown,
  IconButton,
  Button,
  Row,
  Badge,
  Col,
  Panel,
  Container,
  Input,
  Message,
} from 'rsuite'
import AppContext from '../../context/AppContext'
import {
  logout,
  clearSession,
  clearLocalStorage,
  clearSessionStorage,
  setSession,
  setLocalStorage,
} from '../../redux/actions/auth'
import './styles.less'
import { useHistory } from 'react-router-dom'
import Drawered from '../Drawered/Drawered'
import AlertWidget from '../../widgets/confirm/AlertWidget'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import { getGetOtp, getLoginOtp } from '../../redux/actions/loginOtp'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { setAlertMessage } from '../../utils/messageUtil'
import OverlayLoader from '../OverlayLoader/OverlayLoader'
import { config } from '../../config/config'

const MenuPopover = ({ children, ...rest }) => (
  <Popover {...rest} full>
    <Dropdown.Menu key="MenuPopoverMaster">{children}</Dropdown.Menu>
  </Popover>
)

const handleLogout = async () => {
  try {
    let url = await logout()

    clearSession(url)
  } catch (e) {
    clearSession()
  }
}

function PageToolbar({ isLogin, setIsLogin = () => {}, designHash, routerId }) {
  const access_token = localStorage.getItem('access_token')
  const fs = localStorage.getItem('fontSize')

  const history = useHistory()
  // const [notSupport, setNotSupport] = useState()
  const [signin, setSignin] = useState(true)
  const [isSubmit, setIsSubmit] = useState(false)
  const [countNotification, setCountNotification] = useState(0)
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [dataNotification, setDataNotification] = useState()
  const [isSignin, setIsSignin] = useState()
  const [mobileNo, setMobileNo] = useState()
  const [respOTP, setRespOTP] = useState()
  const [otp, setOTP] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [disabledOTP, setDisabledOTP] = useState()
  // const [otpDelay, setOtpDelay] = useState(30000)

  const {
    messages,
    language,
    localePath,
    theme: [themeName, direction],
    onChangeDirection,
    onChangeTheme,
    onChangeFontSize,
  } = React.useContext(AppContext)

  const [minutes, setMinutes] = useState()
  const [notSupport, setNotSupport] = useState()
  //const location = useLocation()
  const [disabledOTPCount, setDisabledOTPCount] = useState(0)

  //const params = new URLSearchParams(location.search)

  const TOKEN_TYPE = localStorage.getItem('token_type')

  useEffect(() => {
    // console.log('isLogin : ', isLogin)
    setIsSignin(isLogin)
  }, [isLogin])

  useEffect(() => {
    if (minutes > 0) {
      const interval = setInterval(() => {
        setMinutes((prevSeconds) => prevSeconds - 1)
      }, 1000)
      return () => clearInterval(interval) // เคลียร์ interval เมื่อ component unmount
    }
  }, [minutes])

  useEffect(() => {
    if (disabledOTPCount > 0) {
      setTimeout(() => {
        setDisabledOTPCount(disabledOTPCount - 1)
      }, 1000)
    }
  }, [disabledOTPCount])

  const handleOnClose = (bool) => {
    setIsSubmit(bool)
  }

  const handleShowCountNoti = (count) => {
    // console.log('ccc => ', count)
    setCountNotification(count)
  }

  const handleOnShowItem = (item, index) => {
    let _item = { ...item, index }
    // console.log('handleOnShowItem => ', _item)
    setDataNotification(_item)
    setIsSubmit(false)
    setIsShowModalHelper(true)
  }

  const handleLogOn = (item, index) => {
    let _item = { ...item, index }
    // console.log('handleOnShowItem => ', _item)
    setDataNotification(_item)
    setIsSubmit(false)
    setIsShowModalHelper(true)
  }

  const handleGetOtp = () => {
    console.log('mobileNo ', mobileNo.length)

    if (mobileNo?.length < 10) {
      setAlertMessage('error', 'กรุณาตรวจสอบ หมายเลขโทรศัพท์')
      return false
    }

    if (mobileNo) {
      var req = {
        phone: mobileNo,
      }
      setOTP('')
      handleCallService(req)
    } else {
      setAlertMessage('error', 'กรุณาระบุ หมายเลขโทรศัพท์')
    }
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)

    try {
      const response = await getGetOtp(request)

      if (response.success) {
        setAlertMessage('success', 'รอรับ OTP ทาง SMS')

        setRespOTP(response?.model)
        setMinutes(response?.model?.validForExpire * 60)
        // setDisabledOTP(true)
        setDisabledOTPCount(30)
      } else {
        setAlertMessage('error', response.errorMessage || DEFAULT_ERR_MSG)
      }
    } catch (error) {
      // console.error('try catch error ', error)
      setAlertMessage('error', DEFAULT_ERR_MSG)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleLoginOtp = () => {
    var req = {
      msisdn: mobileNo,
      token: respOTP.token,
      pin: otp,
    }

    //console.log('handleLoginOtpreq==>', req)
    // onSearch(req)
    handleCallServiceLogin(req)
  }

  const handleCallServiceLogin = async (request) => {
    startLoading()
    try {
      const response = await getLoginOtp(request)

      if (response.success && response?.model?.tokenInfo?.access_token) {
        await clearLocalStorage()
        await clearSessionStorage()

        await setSession(response.model)
        await setLocalStorage(response?.model?.userInfo)

        let redirectUrl = pathname.subProject.subProjectDashboard

        if (redirectUrl) {
          setIsSignin(false)
          setOTP('')
          setMobileNo('')
          setRespOTP('')
          setIsLogin(false)

          window.location.href = redirectUrl
          window.opener = null
        } else {
          setNotSupport(true)
        }
      } else {
        //console.log('d')

        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
      doneLoading()
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.Message || DEFAULT_ERR_MSG)
      doneLoading()
    }
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <ButtonToolbar
        className="page-toolbar custom-magin"
        // style={{ backgroundColor: '#f7f7fa', borderRadius: 10 }}
      >
        {access_token ? (
          <>
            <Whisper placement="bottom" speaker={<Tooltip>ลดขนาดตัวอักษร</Tooltip>}>
              <Icon
                icon="minus"
                size="lg"
                style={{ cursor: 'pointer', padding: '0px 5px 0px 5px' }}
                onClick={() => onChangeFontSize('MINUS')}
              />
            </Whisper>
            <span style={{ fontSize: '0.813rem' }}>ก</span>
            <span style={{ fontSize: '1.25rem' }}>ก</span>
            <Whisper placement="bottom" speaker={<Tooltip>เพิ่มขนาดตัวอักษร</Tooltip>}>
              <Icon
                icon="plus"
                size="lg"
                style={{ cursor: 'pointer', padding: '0px 5px 0px 5px' }}
                onClick={() => onChangeFontSize('PLUS')}
              />
            </Whisper>
            <Whisper placement="bottom" speaker={<Tooltip>ธีมสว่าง/ธีมมืด</Tooltip>}>
              <Icon
                icon={themeName === 'dark' ? 'sun-o' : 'moon-o'}
                size="lg"
                style={{ cursor: 'pointer', padding: '0px 5px 0px 5px' }}
                onClick={onChangeTheme}
              />
            </Whisper>

            <Badge
              content={countNotification > 0 ? countNotification : false}
              style={{ padding: '0px 5px 0px 5px' }}
            >
              <Whisper placement="bottom" speaker={<Tooltip>การแจ้งเตือน</Tooltip>}>
                <Icon
                  icon="bell"
                  size="lg"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsSubmit(true)}
                />
              </Whisper>
            </Badge>

            <Whisper
              placement="bottomEnd"
              trigger="click"
              speaker={
                <MenuPopover>
                  <Dropdown.Item
                    key={'setting'}
                    icon={
                      <Icon
                        icon="setting"
                        size="lg"
                        style={{ marginRight: fs >= 19 ? 20 : fs >= 17 ? 15 : 10 }}
                      />
                    }
                    target="_blank"
                    onClick={() => history.push(pathname.dashboardRootSetting)}
                  >
                    ตั้งค่า Dashboard
                  </Dropdown.Item>
                  {TOKEN_TYPE != 'THR' && (
                    <Dropdown.Item
                      key={'sign-out'}
                      icon={
                        <Icon
                          icon="sign-out"
                          size="lg"
                          style={{ marginRight: fs >= 19 ? 20 : fs >= 17 ? 15 : 10 }}
                        />
                      }
                      target="_blank"
                      onClick={() => handleLogout()}
                    >
                      ออกจากระบบ
                    </Dropdown.Item>
                  )}
                </MenuPopover>
              }
            >
              <IconButton appearance="subtle" icon={<Icon icon={'more'} size="lg" />} />
            </Whisper>
          </>
        ) : (
          <>
            <Whisper
              placement={'bottomEnd'}
              trigger="hover"
              open={signin}
              speaker={
                <Popover
                  style={{
                    width: 380,
                    marginTop: 10,
                    borderStyle: 'solid',
                    borderColor: '#036d59',
                    borderWidth: 2,
                    backgroundColor: '#ffffff',
                  }}
                >
                  <Row style={{ fontWeight: 'bold' }}>
                    <Col xs={18}>
                      <h6>คลิกที่นี่เพื่อเข้าสู่ระบบ</h6>
                    </Col>
                    <Col xs={6} style={{ textAlign: 'right' }}>
                      <h6>
                        <Icon
                          icon="close-circle"
                          size="lg"
                          style={{ color: 'red', cursor: 'pointer' }}
                          onClick={(e) => {
                            setSignin(!signin)
                          }}
                        />
                      </h6>
                    </Col>
                  </Row>
                  <div style={{ padding: 5 }}>
                    <p>
                      ทำการเข้าสู่ระบบก่อนใช้งานระบบ
                      และเมื่อต้องการออกจากระบบให้คลิกอีกครั้งหลังจากเข้าสู่ระบบแล้ว
                    </p>
                  </div>
                </Popover>
              }
            >
              <Button
                appearance="default"
                style={{
                  width: 250,
                  backgroundColor: '#ed7e23',
                  color: '#ffffff',
                  fontWeight: 'bold',
                }}
                onClick={(e) => {
                  setIsSignin(true)
                  setSignin(false)
                  // history.push({
                  //   pathname: '/dashboard',
                  // })
                  // window.location.href = `${process.env.REACT_APP_LOGIN_URL}`
                }}
              >
                <Icon icon="sign-in" style={{ fontSize: 20 }} /> เข้าสู่ระบบ
              </Button>
            </Whisper>
          </>
        )}
      </ButtonToolbar>

      <Drawered
        isShow={isSubmit}
        onClose={handleOnClose}
        countNoti={handleShowCountNoti}
        onShowItem={handleOnShowItem}
      />

      <AlertWidget
        title={'รายละเอียดเพิ่มเติม'}
        show={isShowModalHelper}
        size="sm"
        detail={
          <div>
            {dataNotification ? (
              <>
                <Panel bordered bodyFill>
                  <Container style={{ padding: 10 }}>
                    <div style={{ wordWrap: 'break-word' }}>
                      <Icon icon="envelope-open" size="lg" />
                      {/* <b
                        style={{ marginLeft: 5 }}
                      >{`${dataNotification.index}) ${dataNotification.code}`}</b> */}
                      <b style={{ marginLeft: 5 }}>
                        {/* {`${dataNotification.index}) `}{' '} */}
                        <span dangerouslySetInnerHTML={{ __html: dataNotification.code }} />
                      </b>
                    </div>

                    {dataNotification?.statusName && (
                      <div style={{ wordWrap: 'break-word' }}>
                        <span>สถานะ : {dataNotification.statusName}</span>
                      </div>
                    )}

                    {dataNotification?.date && (
                      <div style={{ wordWrap: 'break-word', marginTop: 5, color: '#808080db' }}>
                        <span>{dataNotification.date}</span>
                      </div>
                    )}
                  </Container>
                </Panel>
              </>
            ) : (
              ''
            )}
          </div>
        }
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />

      <ConfirmWidget
        title={`เข้าสู่ระบบ`}
        show={isSignin}
        size="lg"
        //confirmBtn="เข้าสู่ระบบ"
        cancleBtn={'ปิด'}
        hideConfirm={true}
        // hideCancle = {}
        detail={
          <div className="login-container">
            <div class="login-box">
              <div style={{ marginLeft: 20, marginRight: 20 }}>
                <p>
                  <strong> เข้าสู่ระบบด้วย SSO</strong>
                </p>
                <Button
                  style={{ minWidth: 250, marginBottom: 20, marginTop: 20 }}
                  onClick={() => {
                    // history.push({
                    //   pathname: '/dashboard',
                    // })
                    window.location.href = config.defaultLoginUrl
                    window.opener = null
                  }}
                  size="sm"
                  appearance="ghost"
                >
                  เข้าสู่ระบบ
                </Button>
              </div>
            </div>
            <div class="login-divider"> </div>
            <div class="login-box">
              <div style={{ marginLeft: 20, marginRight: 20 }}>
                <p>
                  <strong> เข้าสู่ระบบด้วย OTP</strong>
                </p>
                <Message
                  style={{ textAlign: 'left', marginTop: 20 }}
                  showIcon
                  type="warning"
                  description="ใช้สำหรับโครงการย่อยเท่านั้น"
                />{' '}
                <Input
                  style={{
                    marginTop: 20,
                  }}
                  placeholder={`เบอร์โทรศัพท์`}
                  value={mobileNo}
                  disabled={respOTP && minutes > 0}
                  onChange={(value, e) => {
                    console.log('value => ', isNaN(value))
                    if (isNaN(value)) {
                    } else {
                      setMobileNo(value)
                    }
                  }}
                />
                <Button
                  style={{ minWidth: 250, marginTop: 20, marginBottom: 20 }}
                  onClick={handleGetOtp}
                  size="sm"
                  appearance="ghost"
                  disabled={disabledOTPCount > 0}
                >
                  {/* {respOTP ? 'ขอ OTP อีกครั้ง' : 'ขอ OTP'} */}
                  {minutes == 0 || respOTP ? 'ขอ OTP อีกครั้ง' : 'ขอ OTP'}
                  {disabledOTPCount > 0 && <>{`(${disabledOTPCount} วิ)`}</>}
                </Button>
                {respOTP && minutes != 0 && (
                  <>
                    <p>
                      {`เลขอ้างอิง : ${respOTP.refno} ( ${Math.floor(minutes / 60)} :
                      ${(minutes % 60).toString().padStart(2, '0')} )`}
                    </p>

                    <Input
                      // style={{ marginTop: 8 }}
                      placeholder={`OTP`}
                      value={otp}
                      onChange={(value) => {
                        setOTP(value)
                      }}
                    />
                    <Button
                      style={{ minWidth: 250, marginBottom: 20, marginTop: 20 }}
                      onClick={handleLoginOtp}
                      size="sm"
                      appearance="ghost"
                      disabled={otp?.length != 6}
                    >
                      เข้าสู่ระบบ
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        }
        onCancle={() => {
          setIsSignin(false)
          setOTP('')
          setMobileNo('')
          setRespOTP('')
          setIsLogin(false)
          sessionStorage.removeItem('openLogin')
        }}
        onConfirm={handleLogOn}
      />
    </>
  )
}

export default PageToolbar
